<div class="header">
  <div>
    <h2>{{ 'pages.analytics.creditAnalytics.title' | translate }}</h2>
    <p class="subtitle">{{ 'pages.analytics.creditAnalytics.subtitle' | translate }}</p>
  </div>

  <!-- Filter oben rechts wie auf den uebrigen Analytics-Seiten. Gelten fuer
       alles darunter; das Kontingent folgt nur dem Kunden. -->
  <div class="filters">
    <nb-button-group size="small" (valueChange)="setDays($event[0])">
      <button nbButtonToggle *ngFor="let p of dayPresets" [value]="p.days" [pressed]="days === p.days">
        {{ p.label }}
      </button>
    </nb-button-group>


    <nb-select size="small" [selected]="botId" (selectedChange)="setBot($event)">
      <nb-option [value]="ALL">{{ 'pages.analytics.creditAnalytics.filter.allBots' | translate }}</nb-option>
      <nb-option *ngFor="let b of botOptions" [value]="b.key">{{ b.label }}</nb-option>
    </nb-select>

    <nb-select size="small" [selected]="courseId" (selectedChange)="setCourse($event)">
      <nb-option [value]="ALL">{{ 'pages.analytics.creditAnalytics.filter.allCourses' | translate }}</nb-option>
      <nb-option *ngFor="let c of courseOptions" [value]="c.key">{{ c.label }}</nb-option>
    </nb-select>

    <nb-select size="small" [selected]="areaChoice" (selectedChange)="setArea($event)">
      <nb-option [value]="ALL">{{ 'pages.analytics.creditAnalytics.filter.allAreas' | translate }}</nb-option>
      <nb-option *ngFor="let a of areas" [value]="a">
        {{ 'pages.analytics.creditAnalytics.area.' + a | translate }}
      </nb-option>
    </nb-select>

    <button nbButton ghost size="small" *ngIf="hasActiveFilter" (click)="resetFilters()">
      <nb-icon icon="close-outline"></nb-icon>
      {{ 'pages.analytics.creditAnalytics.filter.reset' | translate }}
    </button>
  </div>
</div>


<p class="page-hint" *ngIf="loadFailed">
  {{ 'pages.analytics.creditAnalytics.loadError' | translate }}
</p>

<div [nbSpinner]="isLoading" nbSpinnerStatus="primary">

  <!-- KPI — Kundenansicht: was verbraucht wurde, was noch da ist, was es
       gekostet hat, wer es genutzt hat. Vergleich immer gegen das gleich lange
       Fenster davor; ohne Vorzeitraum zeigt die Kachel keinen Prozentwert. -->
  <div class="kpi-grid" *ngIf="summary as s">
    <app-kpi-card
      [label]="'pages.analytics.creditAnalytics.kpi.credits' | translate"
      [value]="credits(s.credits_milli)"
      [formatFunction]="oneDecimal"
      [unit]="'pages.analytics.creditAnalytics.kpi.creditsEuroUnit' | translate: { value: (euro(s.credits_milli) | number: '1.2-2') }"
      [change]="creditsChange"
      icon="flash-outline">
    </app-kpi-card>
    <app-kpi-card
      [label]="'pages.analytics.creditAnalytics.kpi.available' | translate"
      [value]="availableCredits"
      [formatFunction]="wholeNumber"
      [unit]="('pages.analytics.creditAnalytics.kpi.availableOf' | translate: { total: (availableOf | number: '1.0-0') })"
      [change]="null"
      icon="battery-outline">
    </app-kpi-card>
    <app-kpi-card
      [label]="'pages.analytics.creditAnalytics.kpi.payments' | translate"
      [value]="s.payments_eur"
      [formatFunction]="euroFormat"
      [unit]="'pages.analytics.creditAnalytics.kpi.paymentsUnit' | translate"
      [change]="paymentsChange"
      icon="credit-card-outline">
    </app-kpi-card>
    <app-kpi-card
      [label]="'pages.analytics.creditAnalytics.kpi.avgPerLearner' | translate"
      [value]="avgPerLearnerCredits"
      [formatFunction]="avgPerLearnerFormat"
      [unit]="s.learners
               ? ('pages.analytics.creditAnalytics.kpi.learnersUnit' | translate: { n: s.learners })
               : ('pages.analytics.creditAnalytics.kpi.noLearners' | translate)"
      [change]="avgPerLearnerChange"
      icon="people-outline">
    </app-kpi-card>
  </div>

  <!-- ── Kontingent ────────────────────────────────────────────────────────
       Ein Balken, 100 % = Tarif + Zukauf, je Topf satt = verbraucht, hell =
       frei. Darunter je Topf ein Block mit den absoluten Credits. Es wird erst
       der Tarif verbraucht, dann der Zukauf (`credit_limits.py`).
       Stand der LAUFENDEN Abrechnungsperiode — folgt nicht dem Zeitraum.
       Ein Kontingent gehoert genau einem Mandanten; ueber alle Kunden summiert
       waere es bedeutungslos, dann bittet die Karte um eine Kundenwahl. -->
  <nb-card class="quota-card">
    <nb-card-header>
      <h6><nb-icon icon="flash-outline"></nb-icon>{{ 'pages.analytics.creditAnalytics.quota.title' | translate }}</h6>
    </nb-card-header>
    <nb-card-body>
      <p class="empty" *ngIf="summary && !quotaTotal">
        {{ 'pages.analytics.creditAnalytics.quota.none' | translate }}
      </p>

      <ng-container *ngIf="quotaTotal as t">
        <div class="quota-head">
          <span class="quota-head__value">
            {{ 'pages.analytics.creditAnalytics.quota.headline' | translate:
               { used: (t.used | number: '1.0-0'), total: (t.total | number: '1.0-0') } }}
          </span>
          <span class="quota-pill quota-pill--{{ t.level }}">
            {{ 'pages.analytics.creditAnalytics.quota.usedPct' | translate: { pct: (t.pct | number: '1.0-0') } }}
          </span>
        </div>

        <div class="quota-track">
          <div *ngFor="let seg of quotaSegments"
               class="quota-seg quota-seg--{{ seg.key }}"
               [style.width.%]="seg.width"
               [nbTooltip]="('pages.analytics.creditAnalytics.quota.legend.' + seg.key | translate) + ': ' + (seg.credits | number: '1.0-0')"></div>
        </div>

        <div class="quota-pools">
          <div class="quota-pool" *ngFor="let p of quotaPools">
            <div class="quota-pool__name">
              <i class="quota-seg--{{ p.key }}Used"></i>
              {{ 'pages.analytics.creditAnalytics.quota.pool.' + p.key | translate }}
            </div>
            <div class="quota-pool__value">
              {{ p.used | number: '1.0-0' }}
              <span>/ {{ p.total | number: '1.0-0' }}</span>
              <em class="quota-level--{{ p.level }}">{{ p.pct | number: '1.0-0' }} %</em>
            </div>
            <div class="quota-pool__sub" *ngIf="p.key === 'plan'">
              <ng-container *ngIf="summary?.quota?.period_start as since; else planSub">
                {{ 'pages.analytics.creditAnalytics.quota.periodFrom' | translate:
                   { date: (since | date: 'dd.MM.yyyy') } }}
              </ng-container>
              <ng-template #planSub>{{ 'pages.analytics.creditAnalytics.quota.planSub' | translate }}</ng-template>
            </div>
            <div class="quota-pool__sub" *ngIf="p.key === 'purchase'">
              {{ 'pages.analytics.creditAnalytics.quota.purchaseSub' | translate }}
            </div>
          </div>
        </div>
      </ng-container>
    </nb-card-body>
  </nb-card>

  <!-- ── Charts ───────────────────────────────────────────────────────────
       Gleiche Dreischicht wie die uebrigen Analytics-Seiten: nb-card +
       app-chart-header + basic/{donut,bar}-chart, Theme `alphabees`. -->
  <div class="chart-grid">
    <nb-card class="col-span-4">
      <nb-card-header>
        <app-chart-header
          [title]="('pages.analytics.creditAnalytics.charts.timeseries' | translate)
                   + ' · ' + ('pages.analytics.creditAnalytics.granularity.' + granularity | translate)"
          [infoText]="'pages.analytics.creditAnalytics.charts.timeseriesInfo' | translate">
        </app-chart-header>
      </nb-card-header>
      <nb-card-body>
        <p class="empty" *ngIf="!isLoading && !hasSeries">
          {{ 'pages.analytics.creditAnalytics.charts.empty' | translate }}
        </p>
        <app-bar-chart
          *ngIf="hasSeries"
          [labels]="timeseriesLabels"
          [series]="timeseriesSeries"
          [loading]="isLoading">
        </app-bar-chart>
      </nb-card-body>
    </nb-card>

    <nb-card class="col-span-2">
      <nb-card-header>
        <app-chart-header
          [title]="'pages.analytics.creditAnalytics.charts.areaSplit' | translate"
          [infoText]="'pages.analytics.creditAnalytics.charts.areaSplitInfo' | translate">
        </app-chart-header>
      </nb-card-header>
      <nb-card-body>
        <app-donut-chart [series]="areaDonutSeries" [loading]="isLoading"></app-donut-chart>
      </nb-card-body>
    </nb-card>

    <nb-card class="col-span-2">
      <nb-card-header>
        <app-chart-header
          [title]="('pages.analytics.creditAnalytics.charts.dimensionSplit' | translate)
                   + ' ' + ('pages.analytics.creditAnalytics.dimension.' + dimension | translate)"
          [infoText]="'pages.analytics.creditAnalytics.charts.dimensionSplitInfo' | translate">
        </app-chart-header>
      </nb-card-header>
      <nb-card-body>
        <app-donut-chart [series]="dimensionDonutSeries" [loading]="isLoading"></app-donut-chart>
      </nb-card-body>
    </nb-card>
  </div>

  <!-- ── Tabelle ──────────────────────────────────────────────────────────
       Die Gruppierung ist keine Filterung — sie steht deshalb hier, nicht
       oben in der Filterleiste. Sie steuert auch den rechten Donut. -->
  <nb-card>
    <nb-card-header>
      <div class="ca-toolbar">
        <h6><nb-icon icon="list-outline"></nb-icon>{{ 'pages.analytics.creditAnalytics.tableTitle' | translate }}</h6>
        <span class="spacer"></span>
        <nb-select size="small" [selected]="dimension" (selectedChange)="setDimension($event)">
          <nb-option *ngFor="let d of dimensions" [value]="d">
            {{ 'pages.analytics.creditAnalytics.dimension.' + d | translate }}
          </nb-option>
        </nb-select>
      </div>
    </nb-card-header>

    <nb-card-body>
      <p class="empty" *ngIf="!isLoading && rows.length === 0">
        {{ 'pages.analytics.creditAnalytics.empty' | translate }}
      </p>

      <table class="ca-table" *ngIf="rows.length > 0">
        <thead>
          <tr>
            <th>{{ 'pages.analytics.creditAnalytics.col.label' | translate }}</th>
            <th class="num">{{ 'pages.analytics.creditAnalytics.col.credits' | translate }}</th>
            <th class="num">{{ 'pages.analytics.creditAnalytics.col.euro' | translate }}</th>
            <th class="num">{{ 'pages.analytics.creditAnalytics.col.events' | translate }}</th>
            <th class="num" [nbTooltip]="'pages.analytics.creditAnalytics.col.perEventHint' | translate">
              {{ 'pages.analytics.creditAnalytics.col.perEvent' | translate }}
            </th>
            <th class="num">{{ 'pages.analytics.creditAnalytics.col.users' | translate }}</th>
            <th class="num">{{ 'pages.analytics.creditAnalytics.col.avgPerUser' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of rows; trackBy: trackRow" [class.unattributed]="isUnattributed(r)">
            <td>
              <div class="bar" [style.width.%]="barWidth(r)"></div>
              <span class="label">{{ r.label }}</span>
            </td>
            <td class="num">{{ credits(r.credits_milli) | number: '1.0-2' }}</td>
            <td class="num">{{ euro(r.credits_milli) | number: '1.2-2' }}</td>
            <td class="num">{{ r.events | number }}</td>
            <!-- Typischer Verbrauch EINER Ausführung: Median, darunter das obere
                 Ende (p90). Der Mittelwert allein täuscht, sobald ein paar
                 Turns über einer Token-Stufe liegen. -->
            <td class="num per-event">
              <ng-container *ngIf="r.median_credits_milli_per_event !== null; else noAvg">
                {{ credits(r.median_credits_milli_per_event) | number: '1.0-2' }}
                <small *ngIf="r.p90_credits_milli_per_event !== r.median_credits_milli_per_event">
                  {{ 'pages.analytics.creditAnalytics.col.upTo' | translate:
                     { value: (credits(r.p90_credits_milli_per_event) | number: '1.0-2') } }}
                </small>
              </ng-container>
            </td>
            <td class="num">{{ r.distinct_actors | number }}</td>
            <!-- Kein Akteur -> "—", nicht 0. "Keine Aussage moeglich" ist etwas
                 anderes als "null Credits je Nutzer". -->
            <td class="num">
              <ng-container *ngIf="r.avg_credits_milli_per_actor !== null; else noAvg">
                {{ credits(r.avg_credits_milli_per_actor) | number: '1.0-2' }}
              </ng-container>
              <ng-template #noAvg>—</ng-template>
            </td>
          </tr>
        </tbody>
      </table>

      <p class="ca-note" *ngIf="rows.length > 0">
        {{ 'pages.analytics.creditAnalytics.' + (dimension === 'user' ? 'userDimensionNote' : 'userCountNote') | translate }}
      </p>
    </nb-card-body>
  </nb-card>

  <!-- ── Portal-Assistent ────────────────────────────────────────────────
       Der hauseigene Agent im Portal: wer aus der Organisation ihn wie viel
       nutzt. Nur sichtbar, wenn im Zeitraum Runden angefallen sind. -->
  <nb-card *ngIf="agentRows.length > 0">
    <nb-card-header>
      <h6><nb-icon icon="orbi" pack="al"></nb-icon>{{ 'pages.analytics.creditAnalytics.portalAgent.title' | translate }}</h6>
    </nb-card-header>
    <nb-card-body>
      <p class="ca-note">{{ 'pages.analytics.creditAnalytics.portalAgent.hint' | translate }}</p>
      <table class="ca-table">
        <thead>
          <tr>
            <th>{{ 'pages.analytics.creditAnalytics.portalAgent.person' | translate }}</th>
            <th class="num">{{ 'pages.analytics.creditAnalytics.portalAgent.turns' | translate }}</th>
            <th class="num">{{ 'pages.analytics.creditAnalytics.col.credits' | translate }}</th>
            <th class="num">{{ 'pages.analytics.creditAnalytics.col.euro' | translate }}</th>
            <th class="num" [nbTooltip]="'pages.analytics.creditAnalytics.col.perEventHint' | translate">
              {{ 'pages.analytics.creditAnalytics.portalAgent.perTurn' | translate }}
            </th>
            <th class="num">{{ 'pages.analytics.creditAnalytics.portalAgent.tokens' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of agentRows; trackBy: trackRow">
            <td><span class="label">{{ r.label }}</span></td>
            <td class="num">{{ r.events | number }}</td>
            <td class="num">{{ credits(r.credits_milli) | number: '1.0-2' }}</td>
            <td class="num">{{ euro(r.credits_milli) | number: '1.2-2' }}</td>
            <td class="num">
              <ng-container *ngIf="r.median_credits_milli_per_event !== null; else noTurnAvg">
                {{ credits(r.median_credits_milli_per_event) | number: '1.0-2' }}
              </ng-container>
              <ng-template #noTurnAvg>—</ng-template>
            </td>
            <td class="num">{{ r.total_tokens | number }}</td>
          </tr>
        </tbody>
      </table>
    </nb-card-body>
  </nb-card>
</div>
